import React from "react"
import SidePanelLayout from "aldoo-ra/SidePanel"
import Dashboard from "./Dashboard"
import Settings from "./Settings"

/**
 * Aldoo Ads admin — campaign/ad/asset management, KPI dashboards and the
 * cross-site account linking. Side menu comes from the CMS MenuItem
 * "AdminAldooAdsMenu" (Dashboard → /admin/ads/dashboard, Settings →
 * /admin/ads/settings).
 */
const AldooAdsHome = () => {
  return (
    <SidePanelLayout
      menuName="AdminAldooAdsMenu"
      tabs={{
        dashboard: Dashboard,
        settings: Settings,
      }}
    />
  )
}

export default AldooAdsHome
